import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./dashboard/dashboard";
import Login from "./auth/Login";
import Profile from "./dashboard/profile";
import Atc from "./airtimetocash/airtimetocash";
import Help from "./help&support/support";
import Transaction from "./transaction/transaction";
import "./App.css";
import Signup from "./auth/Signup";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/atc" element={<Atc />} />
          <Route path="/help&support" element={<Help />} />
          <Route path="/transaction" element={<Transaction />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
